import { Component, Inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AccountTicketsService } from '@ridango/components';
import { DeviceIdService } from '@ridango/core/lib/services';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-transfer-anonymous-data-modal',
    templateUrl: './transfer-anonymous-data-modal.component.html',
    styleUrls: ['./transfer-anonymous-data-modal.component.scss']
})
export class TransferAnonymousDataModalComponent {
    @Input() modalId;
    @Input() tickets;

    constructor(
        @Inject('ENV') private env: Env,
        private modalCtrl: ModalController,
        private router: Router,
        private translate: TranslateService,
        private accountTicketsService: AccountTicketsService,
        private deviceIdService: DeviceIdService
    ) {}

    async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel', this.modalId);
    }

    async confirm() {
        const deviceToken = this.deviceIdService.getAccessDeviceToken();
        const ticketIds = !this.env.IS_NEW_AFC
            ? this.tickets.map((ticket) => ticket.docNum)
            : this.tickets.map((ticket) => ticket.id);

        this.accountTicketsService.transferTickets(deviceToken, ticketIds).subscribe(async () => {
            await this.modalCtrl.dismiss(null, 'cancel', this.modalId);

            this.router.navigate([this.translate.currentLang, 'account']);
        });
    }
}
